import React from "react";
import FrontEndContext from "../../context/FrontEndContext";
import HeaderBar from "../HeaderBar";
//import HeaderBar from "../HeaderBarTest";
import "./index.css";

export interface PageProps {
  name: string;
  isAuthenticating?: boolean;
  hideUserMenu?: boolean;
  hideAlarmButton?: boolean;
  children?: React.ReactNode;
}



const Page = (props: PageProps) => {
  const { wheelCount } = React.useContext(FrontEndContext);
  //console.log("Wheelcount from context " + wheelCount);
  const paddingValue = wheelCount === 12 ? 20 : 40;//DM Sept 16 2025 12 rows. Check number or rows. If 12 use smaller maragin. Default is 40
  //console.log("Padding value: " + paddingValue);
  const { name, isAuthenticating, hideUserMenu, children, hideAlarmButton } = props;
  return (
    <div className="page-container" style={{ '--page-x-padding': `${paddingValue}px` } as React.CSSProperties}>
      <div className="navbar-container">
        <HeaderBar name={name} hideUserMenu={hideUserMenu || isAuthenticating} hideAlarmButton={hideAlarmButton} />
      </div>
      <div className="child-container">{children}</div>
    </div>
  );
};

export default Page;
